




























































import Vue from 'vue';
import {
	PASSAGE_ROUTE_NAME,
	RAMBLINGS_ROUTE_NAME,
} from '@/router';
import {generateSeed} from '@/client/book';
import {
	MAX_PARAGRAPHS,
	MIN_PARAGRAPHS,
} from '@/constants';

export default Vue.extend({
	name    : 'BookFilters',
	data() {
		return {
			MIN_PARAGRAPHS,
			MAX_PARAGRAPHS,
			key               : this.$store.state.bookMeta.key,
			isRamblings       : this.$route.name === RAMBLINGS_ROUTE_NAME,
			numberOfParagraphs: this.$route.params.numberOfParagraphs,
		};
	},
	computed: {
		seed() {
			return this.$store.state.seed * 1000;
		},
	},
	methods : {
		handleTypeChange(isRamblings: boolean) {
			this.$router.push({
				name  : isRamblings ? RAMBLINGS_ROUTE_NAME : PASSAGE_ROUTE_NAME,
				params: {
					numberOfParagraphs   : this.$store.state.filterOptions.numberOfParagraphs,
					sentencesPerParagraph: this.$store.state.filterOptions.sentencesPerParagraph,
					wordsPerSentence     : this.$store.state.filterOptions.wordsPerSentence,
					minWordLength        : this.$store.state.filterOptions.minWordLength,
				},
			});
		},
		handleKeyChange(key: string) {
			this.$router.push({
				params: {
					bookKey: key,
				},
			});
		},
		reseed() {
			this.$router.push({
				params: {
					seed: generateSeed(),
				},
			});
		},
		handleParagraphChange($event: Event) {
			this.$router.push({
				params: {
					numberOfParagraphs: ($event.target as HTMLInputElement).value,
				},
			});
		},
	},
});
